/* Svensk katalog for locale-no.js (del 1 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'common.save': 'Spara ändringar',
  'common.saving': 'Sparar...',
  'common.cancel': 'Avbryt',
  'common.hoursMinutes': '{h} h {m} min',
  'common.delete': 'Ta bort',
  'common.confirmTitle': 'Är du säker?',
  'common.continue': 'Fortsätt',
  'account.view': 'Kontovy',
  'account.relevant': 'Relevanta',
  'account.all': 'Alla',
  'account.favorites': 'Favoriter',
  'account.addFavorite': 'Lägg till i favoriter',
  'account.removeFavorite': 'Ta bort från favoriter',
  'account.searchHint': 'Sök namn, nummer eller t.ex. 5x',
  'common.working': 'Arbetar...',
  'common.close': 'Stäng',
  'common.on': 'På',
  'common.off': 'Av',
  'common.active': 'Aktiv',
  'common.yes': 'Ja',
  'common.no': 'Nej',
  'month.short.1': 'Jan',
  'month.short.2': 'Feb',
  'month.short.3': 'Mar',
  'month.short.4': 'Apr',
  'month.short.5': 'Maj',
  'month.short.6': 'Jun',
  'month.short.7': 'Jul',
  'month.short.8': 'Aug',
  'month.short.9': 'Sep',
  'month.short.10': 'Okt',
  'month.short.11': 'Nov',
  'month.short.12': 'Dec',
  'ui.summary.title': 'Sammanfattning',
  'ui.summary.exVat': 'Summa exkl. moms',
  'ui.summary.vat': 'Moms',
  'ui.summary.total': 'Totalsumma',
  'ui.more': 'Mer',
  'ui.filter': 'Filter',
  'ui.filterReset': 'Återställ filter',
  'ui.filterChoices': 'Filterval',
  'ui.period': 'Period',
  'ui.from': 'Från',
  'ui.to': 'Till',
  'ui.fromMonth': 'Från månad',
  'ui.toMonth': 'Till månad',
  'ui.fromDate': 'Från datum',
  'ui.toDate': 'Till datum',
  'ui.today': 'I dag',
  'ui.wholeYearTitle': 'Hela {year}',
  'ui.quick.wholeYear': 'Hela året',
  'ui.quick.ytd': 'Hittills i år',
  'ui.quick.thisTerm': 'Denna period',
  'ui.quick.lastYear': 'Föregående år',
  'ui.term': 'Period {n}',
  'ui.amountSearch': 'Sök på belopp',
  'ui.amountFrom': 'Belopp från',
  'ui.amountTo': 'Belopp till',
  'list.search': 'Sök',
  'list.copy': 'Kopiera',
  'list.copied': 'Kopierat: {text}',
  'list.export': 'Exportera',
  'list.download': 'Ladda ned',
  'list.downloaded': '{label} nedladdad',
  'list.nothingToExport': 'Inga rader att exportera',
  'list.downloading': '{label} laddas ned …',
  'list.upload': 'Ladda upp',
  'list.add': 'Lägg till',
  'list.archiveTitle': 'Flytta till arkiv?',
  'list.archiveConfirm': 'Flytta till arkiv',
  'list.deleteTitle': 'Ta bort?',
  'list.delete': 'Ta bort',
  'list.archiveBody': 'Vill du flytta {name} till arkivet? Kunden döljs från aktiva kundlistor, men fakturor, betalningar och historik behålls. Detta kan inte ångras härifrån.',
  'list.deleteBody': 'Är du säker på att du vill ta bort {name}? Detta kan inte ångras.',
  'crm.prospect': 'Prospekt',
  'crm.active': 'Aktiv',
  'crm.quoteSent': 'Offert skickad',
  'crm.pause': 'Pausad',
  'badge.paid': 'Reglerad',
  'badge.active': 'Aktiv',
  'badge.sent': 'Skickad',
  'badge.draft': 'Utkast',
  'badge.created': 'Inte skickad',
  'badge.overdue': 'Förfallen',
  'badge.credited': 'Krediterad',
  'badge.inactive': 'Passiv',
  'badge.ok': 'Inlämnad',
  'badge.no': 'Inte inlämnad',
  'badge.soon': 'Förfaller snart',
  'status.draft': 'Utkast',
  'status.created': 'Inte skickad',
  'status.sent': 'Skickad',
  'status.paid': 'Betald',
  'status.overdue': 'Förfallen',
  'status.credited': 'Krediterad',
  'app.loading': 'Läser in din bokföring…',
  'app.loadingPersonalFinance': 'Läser in din privatekonomi…',
  'app.loadingEmployeePortal': 'Läser in din personalportal…',
  'project.cost.field': 'Projekt',
  'project.cost.none': 'Inte på projekt',
  'project.cost.billable': 'Vidarefaktureras kunden',
  'project.cost.pickTitle': 'Välj projekt',
  'project.cost.search': 'Sök efter projekt eller kund',
  'project.cost.searchEmpty': 'Inga projekt matchar sökningen.',
  'project.cost.toProject': 'Till projekt',
  'app.employeePortalVerifyTitle': 'Bekräfta din e-postadress',
  'app.employeePortalVerifyText': 'Vi har skickat en bekräftelselänk till {{email}}. Det kan ta några minuter innan den kommer. Kontrollera även skräpposten. Öppna länken för att fortsätta.',
  'app.employeePortalVerifyResend': 'Skicka länken igen',
  'app.employeePortalVerifySent': 'Bekräftelselänken har skickats igen.',
  'app.employeePortalVerifyAlready': 'E-postadressen är redan bekräftad. Läs in sidan igen.',
  'app.employeePortalVerifyFailed': 'Kunde inte skicka bekräftelselänk.',
  'app.emailVerifyCheck': 'Jag har bekräftat',
  'app.emailVerifyConfirmed': 'E-postadressen är bekräftad.',
  'app.emailVerifyNotConfirmed': 'E-postadressen är inte bekräftad än. Öppna länken i e-postmeddelandet och försök igen.',
  'app.emailVerifyCheckFailed': 'Kunde inte kontrollera e-postadressen.',
  'app.emailVerifyInitialFailed': 'Kontot skapades, men bekräftelselänken kunde inte skickas. Försök skicka den igen.',
  'app.placeholder.title': 'Den här sidan är på väg',
  'app.placeholder.text': 'Vi putsar på de sista detaljerna här. Titta in snart!',
  'app.nobusiness.title': 'Vad vill du börja med?',
  'app.nobusiness.text': 'Du är inloggad, men har inget företag i Plumme än.',
  'app.nobusiness.create': 'Skapa företag',
  'app.nobusiness.signOut': 'Logga ut',
  'common.signOut': 'Logga ut',
  'auth.sub.default': 'Enkel bokföring för små företag',
  'auth.sub.forgot': 'Återställ ditt lösenord',
  'auth.sub.sent': 'Kontrollera din e-post',
  'auth.sub.signup': 'Skapa konto och konfigurera företaget',
  'auth.language': 'Språk',
  'auth.invite.household': 'Du har fått en inbjudan till hushållsekonomi. Logga in, eller skapa ett konto med e-postadressen som inbjudan skickades till.',
  'auth.invite.business': 'Du har fått en klientinbjudan. Ange e-postadressen som inbjudan skickades till, så öppnar vi inbjudan efter inloggning.',
  'auth.email': 'E-post',
  'auth.emailPlaceholder': 'din@epost.no',
  'auth.password': 'Lösenord',
  'auth.name': 'Namn',
  'auth.namePlaceholder': 'Ditt namn',
  'auth.passwordMin': 'Minst 6 tecken',
  'auth.showPassword': 'Visa lösenord',
  'auth.hidePassword': 'Dölj lösenord',
  'auth.remember': 'Kom ihåg mig',
  'auth.forgot': 'Glömt lösenordet?',
  'auth.signIn': 'Logga in',
  'auth.signingIn': 'Loggar in...',
  'auth.noAccount': 'Har du inget konto?',
  'auth.createAccount': 'Skapa konto',
  'auth.creating': 'Skapar...',
  'auth.backToLogin': 'Tillbaka till inloggning',
  'auth.forgotCopy': 'Ange e-postadressen du loggar in med, så skickar vi en länk för att skapa ett nytt lösenord.',
  'auth.sendResetLink': 'Skicka återställningslänk',
  'auth.sending': 'Skickar...',
  'auth.sentCopy': 'Vi har skickat en länk till {email}. Följ länken i e-postmeddelandet för att skapa ett nytt lösenord.',
  'auth.wrongEmail': 'Använde vi fel e-post? Försök igen',
  'auth.error.signIn': 'Inloggningen misslyckades.',
  'auth.error.reset': 'Kunde inte skicka återställningslänk.',
  'auth.error.signUp': 'Kunde inte skapa konto.',
  'capture.scan': 'Skanna verifikation',
  'capture.toInbox': 'Till Inkorg',
  'capture.toPurchase': 'Till Betalt inköp',
  'capture.analysisFailed': 'Verifikationen laddades upp, men analysen misslyckades.',
  'capture.readyInPurchase': 'Verifikationen är klar i Betalt inköp.',
  'capture.uploadingToInbox': 'Laddar upp verifikationen till Inkorg ...',
  'capture.uploadedToInbox': 'Verifikation uppladdad till Inkorg.',
  'capture.uploadFailed': 'Kunde inte ladda upp verifikationen.',
  'capture.analysisTimedOut': 'Verifikationen har skickats in. Analysen tar lite tid och fortsätter i bakgrunden.',
  'capture.paymentDialogLoadFailed': 'Kunde inte läsa in betalningsalternativen. Försök igen.',
  'nav.home': 'Hem',
  'nav.aiBookkeeper': 'AI Redovisningskonsult',
  'nav.aiAdvisor': 'AI Rådgivare',
  'nav.newSale': 'Ny försäljning',
  'nav.invoices': 'Fakturalista',
  'nav.otherSales': 'Annan försäljning',
  'nav.customers': 'Kunder',
  'nav.products': 'Produkter',
  'nav.projects': 'Projekt',
  'nav.subscriptions': 'Avtal',
  'nav.newPurchase': 'Nytt inköp',
  'nav.manualEntry': 'Fri kontering',
  'nav.suppliers': 'Leverantörer',
  'nav.assets': 'Tillgångar',
  'nav.inventory': 'Varulager',
  'nav.inbox': 'Inkorg',
  'nav.incomeStatement': 'Resultaträkning',
  'nav.trialBalance': 'Råbalans',
  'nav.budget': 'Budget',
  'nav.filings': 'MVA-melding',
  'nav.taxReturn': 'Skattemelding',
  'nav.yearEndClosing': 'Bokslut',
  'nav.annualAccounts': 'Årsredovisning',
  'nav.payroll': 'Lön',
  'nav.mileageLog': 'Körjournal',
  'nav.vouchers': 'Transaktioner',
  'nav.bank': 'Bank',
  'nav.myPage': 'Min sida',
  'nav.activityLog': 'Aktivitetslogg',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Inställningar',
  'navgroup.sales': 'Försäljning',
  'navgroup.purchases': 'Inköp',
  'navgroup.reports': 'Rapporter',
  'navgroup.filings': 'Inlämningar',
  'navgroup.employees': 'Anställda',
  'navgroup.other': 'Annat',
  'navgroup.miscellaneous': 'Övrigt',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Inställningar',
  'navhelp.home': 'Din startsida – nyckeltal, diagram och genvägar för att registrera försäljning och inköp.',
  'navhelp.aiBookkeeper': 'SuperPlumma går igenom bank, verifikationer, moms och tidsfrister och skapar förslag. Du kontrollerar och godkänner innan något bokförs.',
  'navhelp.aiAdvisor': 'Ekonomisk rådgivning från SuperPlumma – hälsopoäng, rekommendationer, kassaflödesprognos, risk och skatteoptimering.',
  'navhelp.newSale': 'Skapa en ny faktura eller offert till en kund. Försäljningen bokförs automatiskt.',
  'navhelp.invoices': 'Översikt över alla fakturor och offerter – status, förfallodag och betalning.',
  'navhelp.customers': 'Ditt kundregister. Lägg till och redigera kunder du fakturerar.',
  'navhelp.products': 'Varor och tjänster du säljer, med pris och momssats – klara att använda på fakturor.',
  'navhelp.projects': 'För timmar på projekt och aktiviteter, följ vad som har gjorts och gör ofakturerade timmar till fakturautkast.',
  'navhelp.subscriptions': 'Abonnemang, återkommande fakturor och kundlistor med kontroll över automatiska utskick.',
  'navhelp.newPurchase': 'Registrera ett inköp eller en leverantörsfaktura med verifikation, leverantör, belopp och konto.',
  'navhelp.manualEntry': 'Bokför manuellt direkt på konto när du behöver full kontroll över konteringen.',
  'navhelp.suppliers': 'Ditt leverantörsregister – namn, org.nr och kontonummer för utbetalningar.',
  'navhelp.assets': 'Inventarier och bestående värden som skrivs av över tid.',
  'navhelp.inventory': 'Inventering och värdet av ditt varulager. Dokumentera inventeringen och bokför förändringen i lagret.',
  'navhelp.inbox': 'Verifikationer som har kommit in men inte bokförts ännu. Dra dem till rätt bokföring.',
  'navhelp.incomeStatement': 'Intäkter minus kostnader – här ser du om företaget går med vinst.',
  'navhelp.trialBalance': 'Saldo på alla konton – underlaget för dina bokföringsrapporter.',
  'navhelp.budget': 'Lägg upp en budget och följ hur du ligger till mot målen.',
  'navhelp.filings': 'Kontrollera momsunderlaget för varje period. Själva deklarationen lämnas hos Skatteetaten.',
  'navhelp.taxReturn': 'Utkast till skattemelding baserat på bokföringen – kontrollera siffrorna innan du lämnar in hos Skatteetaten.',
  'navhelp.yearEndClosing': 'Steg för steg genom allt som måste göras för att stänga räkenskapsåret.',
  'navhelp.annualAccounts': 'Resultat, balans, noter och signering. Årsredovisningen lämnas till Regnskapsregisteret utanför Plumme.',
  'navhelp.payroll': 'Kör lön, skapa lönebesked och bokför lönen. A-meldingen lämnas utanför Plumme.',
  'navhelp.mileageLog': 'Registrera körning i jobbet och se kilometer och avdrag för året.',
  'navhelp.vouchers': 'Samlad översikt över bokförda transaktioner och tillhörande verifikationer – sök och hitta igen.',
  'navhelp.bank': 'Ladda upp kontoutdrag och stäm av bankkontona mot bokföringen.',
  'navhelp.myPage': 'Din egen profil och dina inställningar som användare.',
  'navhelp.activityLog': 'Fullständig historik över vad som har gjorts i bokföringen och av vem.',
  'navhelp.altinn': 'Genväg till inlämningar och post i Altinn.',
  'navhelp.settings': 'Inställningar för bolaget, bokföringen och appen.',
  'navhelp.fallback': 'Öppna {label}.',
  'route.home': 'Hem',
  'route.newSale': 'Ny försäljning',
  'route.newSaleliste': 'Fakturalista',
  'route.customers': 'Kunder',
  'route.products': 'Produkter',
  'route.projects': 'Projekt',
  'route.aiBookkeeper': 'AI Redovisningskonsult',
  'route.aiAdvisor': 'AI Rådgivare',
  'route.newPurchase': 'Betalt köp',
  'route.manualEntry': 'Fri kontering',
  'route.vouchers': 'Transaktioner',
  'route.suppliers': 'Leverantörer',
  'route.assets': 'Tillgångar',
  'route.filings': 'Inlämningar',
  'route.inbox': 'Inkorg',
  'route.documentation': 'Dokumentation',
  'route.mileageLog': 'Körjournal',
  'route.bank': 'Bank',
  'route.altinn': 'Altinn',
  'route.settings': 'Inställningar',
  'route.otherSales': 'Övrig försäljning',
  'route.subscriptions': 'Avtal',
  'route.incomeStatement': 'Resultaträkning',
  'route.trialBalance': 'Råbalans',
  'route.budget': 'Budget',
  'route.payroll': 'Lön',
  'route.taxReturn': 'Skattemelding',
  'route.yearEndClosing': 'Bokslut',
  'route.annualAccounts': 'Årsredovisning',
  'route.myPage': 'Min sida',
  'route.employeePortal': 'Personalportal',
  'route.activityLog': 'Aktivitetslogg',
  'route.personalFinance': 'Privatekonomi',
  'shell.openMenu': 'Öppna menyn',
  'shell.closeMenu': 'Stäng menyn',
  'shell.collapseMenu': 'Fäll ihop menyn',
  'shell.showLabels': 'Visa menytext',
  'shell.hideLabels': 'Dölj menytext',
  'shell.designSystem': 'Designsystem ↗',
  'shell.customizeMenu': 'Anpassa menyn',
  'shell.customizeHelpTitle': 'Anpassa menyn',
  'shell.customizeHelp': 'Välj vilka sidor som ska visas i sidomenyn. Dölj de du inte använder för att hålla menyn städad.',
  'shell.customizeTitle': 'Anpassa sidomenyn',
  'shell.customizeVisible': '{visible} av {total} synliga',
  'shell.customizeLead': 'Stäng av sidor du inte använder, så döljs de från sidomenyn. Du kan slå på dem igen när som helst.',
  'shell.customizeAllPages': 'Alla sidor',
  'shell.customizeAiMode': 'AI-läge',
  'shell.customizeAlwaysOn': 'Alltid på',
  'shell.customizeDone': 'Klar',
  'shell.camCapture': 'Fotografera verifikation',
  'shell.camHelp': 'Ta en bild av en verifikation med kameran och ladda upp den direkt till Inkorgen eller som ett nytt köp.',
  'shell.moreOptions': 'Fler val',
  'shell.search': 'Sök',
  'shell.searchAll': 'Sök i allt',
  'shell.searchHelp': 'Sök i aktivt företag — kunder, fakturor, produkter, verifikationer, projekt, sidor och hjälp. Tryck för att öppna sökningen (kortkommando: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Sök i allt — fakturor, kunder, verifikationer…',
  'shell.searchEnterHint': 'för att se alla träffar',
  'shell.companyHelpTitle': 'Välj företag eller arbetsgivare',
  'shell.companyHelp': 'Växla mellan bokföringarna du sköter och arbetsgivarna du är anställd hos. Allt du ser i appen gäller det valda företaget.',
  'shell.yearHelpTitle': 'Räkenskapsår',
  'shell.yearHelp': 'Välj vilket räkenskapsår du arbetar med. Alla siffror och inlämningar gäller det valda året.',
  'shell.theme.helpTitle': 'Ljust / mörkt tema',
  'shell.theme.help': 'Växla mellan ljust och mörkt utseende i hela appen. Valet sparas till nästa gång.',
  'shell.theme.toLight': 'Byt till ljust tema',
  'shell.theme.toDark': 'Byt till mörkt tema',
  'shell.theme.light': 'Ljust tema',
  'shell.theme.dark': 'Mörkt tema',
  'shell.bg.label': 'Bakgrundsfärg',
  'shell.bg.title': 'Bakgrundsfärg för den här sidan',
  'shell.bg.help': 'Välj bakgrundsfärg för just den här sidan. Färgen sparas per sida.',
  'shell.bg.menuTitle': 'Bakgrundsfärg · den här sidan',
  'shell.bg.default': 'Plommon',
  'shell.bg.mint': 'Mint',
  'shell.bg.varm': 'Varm',
  'shell.bg.sky': 'Blå',
  'shell.bg.rose': 'Rosa',
  'shell.bg.skog': 'Skog',
  'skin.title': 'Utseende',
  'skin.standard': 'Standard',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Klassisk',
  'skin.klassiskSub': 'Stilren',
  'shell.client.employers': 'Dina arbetsgivare',
  'shell.client.employer': 'Arbetsgivare',
  'shell.client.employee': 'Anställd',
  'shell.client.private': 'Privat',
  'shell.client.firm': 'Redovisningsbyrå',
  'shell.client.firmSub': 'Klientöversikt och avstämning',
  'rf.firm': 'Redovisningsbyrå',
  'rf.role.owner': 'Ägare',
  'rf.role.admin': 'Administratör',
  'rf.role.employee': 'Medarbetare',
  'rf.group.firm': 'Redovisningskonsult',
  'rf.group.team': 'Teamchatt',
  'rf.group.other': 'Övrigt',
  'rf.nav.clients': 'Klientöversikt',
  'rf.nav.reconciliation': 'Avstämning',
  'rf.nav.control': 'Kontroll',
  'rf.nav.teamchat': 'Teamchatt',
  'rf.nav.members': 'Medarbetare',
  'rf.nav.clientList': 'Klienter',
  'rf.client.pageBody': 'Koppla byrån till sina klienter och tilldela medarbetare till uppdragen.',
  'rf.client.addTitle': 'Koppla till en klient',
  'rf.client.addBody': 'Klienten måste ha ett Plumme-konto för sitt företag. Byrån får åtkomst först när klienten har accepterat.',
  'rf.client.billedTo': 'Vem betalar',
  'rf.client.billedToClient': 'Klienten betalar själv',
  'rf.client.billedToFirm': 'Byrån betalar',
  'rf.client.request': 'Skicka förfrågan',
  'rf.client.requesting': 'Skickar …',
  'rf.client.requested': 'Förfrågan har skickats till klienten',
  'rf.avst.noClient': 'Välj en klient först',
  'rf.avst.allClients': 'Alla klienter',
  'rf.avst.thisClient': 'Den här klienten',
  'rf.avst.noClientBody': 'Avstämning gäller en klient i taget. Öppna en klient från klientöversikten, så följer avstämningsmappen med.',
  'rf.client.requestedMailFailed': 'Förfrågan har skickats, men aviseringen via e-post kunde inte skickas. Klienten ser den vid nästa inloggning.',
  'rf.client.requestedNoRecipient': 'Förfrågan har skickats, men företaget har ingen ägare eller administratör att avisera. Kontakta klienten själv.',
  'rf.client.noneTitle': 'Inga klienter ännu',
  'rf.client.noneBody': 'Koppla byrån till en klient med organisationsnumret. Klienten måste godkänna innan ni får åtkomst.',
  'rf.client.pendingBody': 'Klienten måste godkänna förfrågan i sitt eget Plumme-konto. Ingen på byrån har åtkomst innan dess.',
  'rf.client.assignWho': 'Tilldela uppdraget',
  'rf.client.assignPick': 'Välj medarbetare',
  'rf.client.assignRole': 'Roll i uppdraget',
  'rf.client.assign': 'Tilldela',
  'rf.client.assigned': 'Medarbetaren har tilldelats klienten',
  'rf.client.end': 'Avsluta uppdraget',
  'rf.client.ended': 'Uppdraget är avslutat',
  'rf.client.endConfirm': 'Avsluta uppdraget för {name}? Åtkomsten som byrån har gett medarbetarna dras in samtidigt.',
  'fe.title': 'En redovisningsbyrå begär åtkomst',
  'fe.theFirm': 'Byrån',
  'fe.body': 'Om du godkänner får de medarbetare som byrån tilldelar uppdraget åtkomst till din bokföring. Du kan avsluta samarbetet när som helst.',
  'fe.billedToFirm': 'Byrån betalar abonnemanget',
  'fe.billedToClient': 'Du betalar abonnemanget själv',
  'fe.accept': 'Ge åtkomst',
  'fe.accepting': 'Godkänner …',
  'fe.accepted': '{firm} har nu åtkomst till bokföringen.',
  'fe.decline': 'Avböj',
  'fe.declined': 'Förfrågan har avböjts.',
  'fi.title': 'Du är inbjuden som medarbetare',
  'fi.theFirm': 'byrån',
  'fi.body': 'Inbjudan ger dig åtkomst till själva byrån. Åtkomst till den enskilda klienten får du först när byrån tilldelar dig ett uppdrag.',
  'fi.verifyFirst': 'Bekräfta din e-postadress först. Vi har skickat en ny bekräftelselänk.',
  'fi.accept': 'Gå med',
  'fi.accepting': 'Går med …',
  'fi.accepted': 'Du är nu medarbetare i {firm}.',
  'fi.acceptFailed': 'Det gick inte att godkänna inbjudan.',
});

window.PlummeI18n.register("sv", {"nav.kjopsoversikt": "Inköpslista", "route.kjopsoversikt": "Inköpslista"});
